<template>
  <div>
    <div
      v-if="STATUS.LOADED"
      class="LegalDocs--content"
    >
      {{ compiledMarkdown }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import marked from 'marked';

const LegalModule = 'App/LegalDocs';
export default {
  name: 'TermsOfUseView',
  computed: {
    ...mapState(LegalModule, {
      legalData: state => state.data,
      STATUS: state => state.STATUS,
    }),
    compiledMarkdown() {
      return marked(this.legalData.documents.termsOfUse, { sanitize: true });
    },
  },
};
</script>
